// extracted by mini-css-extract-plugin
module.exports = {"productImage":"_32tyt","productBadge":"_1Bacd","badge":"c8VyL","defaultImage":"_2bJRQ"};